export default "__VITE_ASSET__642ff55d__"